/**
 * Validates a user-typed quick-add key (selector `Key` or identifier `Primary Key`)
 * before it is woven into a JSONata bracket selector or a `path=…; key=…` line.
 *
 * Rules:
 * - Trim whitespace.
 * - Reject empty values.
 * - Reject `;` (would corrupt `path=…; key=…` line splitting).
 * - Reject newlines (UX safety; lines are stored one per textarea row).
 *
 * Quoting / bracket escaping for the eventual JSONata expression stays in
 * `buildIdentifierBracketSelector` (see `selectorBuilderUtils.js`).
 *
 * @param {unknown} raw
 * @returns {{ ok: true, value: string } | { ok: false, message: string }}
 */
export function validateQuickAddKey(raw) {
    const value = String(raw ?? '').trim();
    if (value === '') {
        return { ok: false, message: 'Enter a key.' };
    }
    if (value.includes(';')) {
        return { ok: false, message: 'Key cannot contain ";".' };
    }
    if (/[\r\n]/.test(value)) {
        return { ok: false, message: 'Key cannot contain a newline.' };
    }
    return { ok: true, value };
}
